export function formatShortId(value: string): string {
  const [firstPart] = value.split('-');
  return firstPart || value;
}

export function formatDateTime(value: string | null): string {
  if (!value) {
    return 'Not available';
  }

  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  }).format(new Date(value));
}

export function formatDuration(seconds: number | null): string {
  if (seconds === null) {
    return 'N/A';
  }

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
}

export function formatStatus(value: string): string {
  return value.replace(/_/g, ' ');
}

export function formatNullable(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return 'Not available';
  }
  return String(value);
}

export function formatBoolean(value: boolean | null): string {
  if (value === null) {
    return 'Default';
  }
  return value ? 'Yes' : 'No';
}

export function formatJson(value: unknown): string {
  if (value === null || value === undefined) {
    return 'Not available';
  }
  return JSON.stringify(value);
}
